"use client";

import PrimaryButton from "@/src/shared/button/PrimaryButton";
import FloatingInput from "@/src/shared/form/FloatingInput";
import { useRef, useState, useTransition } from "react";
import CodeVerification from "../modal/CodeVerification";
import { Controller, useForm } from "react-hook-form";
import Logger from "@/src/exceptions/Logger";
import { useAppDispatch } from "@/src/store/hook";
import { sendVerificationCode } from "@/src/store/module/verification";
import { IBackendAPIDataResponse } from "@/src/lib/axios/types";
import FormValidator, { useValidation } from "@/src/lib/FormValidation";
import { deleteUserAccount } from "@/src/store/module/user";
import { Toast } from "primereact/toast";
import { VerificationType } from "@/src/types/verification";
import PageFeedback from "@/src/shared/feedback/PageFeedback";


export default function AccountClosureRequest(props: any) {

    const dispatch = useAppDispatch();
    
    const toast:any = useRef(null);
    const [open, setOpen] = useState(false);
    const [processing, startProcessing] = useTransition();
    const [validation, setValidation] = useState<any>(null);
    const [email, setEmail] = useState<string>("");

    const [success, setSuccess] = useState(false);

    const validate = useValidation();

    const handleCodeVerification = async (code:string) => {
        let res:IBackendAPIDataResponse;
        try {
            res = await dispatch(deleteUserAccount({
                email,
                verification_code: code,
            })).unwrap();
        } catch (error) {
            Logger.error("Account closure error: ", error);
            res = {
                success: false,
                data: null,
                message: "Something went wrong! We are working on it."
            };
        }

        return res;
    }

    const makeRequest = () => {
        startProcessing(async () => {
            validate.make({
                fields: {email},
                rules: {
                    email: ["required", ],
                }
            });
    
            // Logger.log("Validator Fails: ", validate.fails())
            // Logger.log("Validator Errors: ", validate.errors())
            // Logger.log("Validator Form Field Data: ", email)
    
            if (validate.fails()) {
                return;
            }

            
            const res = await sendCode();

            Logger.error("Verification code response: ", res)

            if (res.success) {
                setOpen(true);
            } else {
                Logger.error("Verification code Error: ", res.message)
                if (res.message instanceof Object) {
                    validate.setError(res.message)
                } else {
                    toast.current.show({
                        severity: "error",
                        summary: res.message,
                        life: 2000
                    })
                }
            }

        })


    }

    const sendCode = async (): Promise<IBackendAPIDataResponse> => {
        try {
            const res: IBackendAPIDataResponse = await dispatch(sendVerificationCode({
                email,
                type: VerificationType.ACCOUNT_CLOSURE,
            })).unwrap();

            Logger.info("Verification code reponse: ", res);

            return res;
        } catch (error) {
            Logger.error("Verifcation code send: ", error);
            return {
                success: false,
                data: null,
                message: "Somthing went wrong. We are working on it.",
            }
        }
    }

    return (
        <>
            <Toast ref={toast} />
            <CodeVerification 
                open={open} 
                email={email}
                onResend={sendCode}
                onVerify={handleCodeVerification}
                onHide={(success?:boolean) => {
                    if (success == true) setSuccess(true);
                    setOpen(false)
                }}
            />

            {success? (
                <PageFeedback type="success" title="Account Closed Successfully!">
                    <p>
                        Your account associated with <span className="text-gray-200">{ email }</span> has been closed successfully and your data clearing is in progress.
                    </p>
                </PageFeedback>
            ) : (
                <div className="w-150 sm:max-w-md mt-10 px-10 md:px-12 py-10 bg-white dark:bg-gray-800 shadow-md overflow-hidden sm:rounded-lg">
                    <h2 className="text-[23px] font-bold text-gray-700 dark:text-gray-300 text-center mt-2 mb-6">
                        Close Account
                    </h2>
                    <div className="pb-10">
                        <p className="text-gray-400 text-center text-sm md:text-lg">
                            Please enter your registered email address to proceed with closing your <span className="text-gray-200">Enanpay</span> account.
                        </p>
                    </div>
    
                    <div className="flex flex-col gap-y-5">
                        <FloatingInput
                            id="email"
                            type="email"
                            // className="mt-1 block w-full"
                            autofocus
                            autocomplete="username"
                            placeholder="Email Address"
                            hasError={validate.hasErrors("email")}
                            errorMessage={validate.getError("email")}
                            value={email}
                            onChange={(e:any) => {
                                validate.clear("email");
                                setEmail(e.target.value);
                            }}
                        />
    
                        <PrimaryButton 
                            type="button" 
                            disabled={processing}
                            className="w-full flex justify-center py-5 text-[15px]"
                            onClick={makeRequest}
                        >
                            Close My Account
                        </PrimaryButton>
                    </div>
                </div>

            )}

        </>
    );
}